import React from 'react';
import PropTypes from 'prop-types';

export const PageHeader = ({ title, actionComponent }) => {
    const hasSecondColumn = !!actionComponent;
    return (
        <div className="row my-3">
            <div
                className={`d-flex align-items-center justify-content-md-center ${
                    hasSecondColumn ? ' col-7 offset-md-3 col-md-6' : ' col-12'
                }`}>
                <h1
                    data-myt-header-text
                    className={`text-nowrap text-styled mb-0 heading-berlin`}>
                    {title}
                </h1>
            </div>
            {actionComponent && (
                <div className="col-5 text-right col-md-3">
                    {actionComponent}
                </div>
            )}
        </div>
    );
};

PageHeader.propTypes = {
    title: PropTypes.node.isRequired,
    actionComponent: PropTypes.node
};
